<template>
    <FilterPage v-on="$listeners" @reset="handleReset">
        <template v-slot:title>
            Salles
            <template v-if="value.venues.rooms.is_tent">
                <small class="ml-2">(Chapiteau)</small>
            </template>
        </template>

        <div class="my-4">
            <b-form-checkbox v-model="value.venues.rooms.is_tent" @change="handleIsTentChanged">
                Rechercher un chapiteau
            </b-form-checkbox>
        </div>
        <div class="list-group">
            <template v-for="range in ranges">
                <div class="list-group-item">
                    <RangeCriteria
                        :value="rangeValue(range.name)"
                        :min="range.min"
                        :max="range.max"
                        :label="range.label"
                        :name="range.name"
                        :unit="rangeUnit(range.name)"
                        @input="handleChanged(range.name, $event)"
                    />
                </div>
            </template>
        </div>
    </FilterPage>
</template>

<script>
    import { BFormCheckbox } from 'bootstrap-vue';
    import FilterPage from "../../../FilterPage";
    import RangeCriteria from "../../criterias/Range";
    import { getRoomsCriterias, roomValue, isRoomValueInMeter } from "../../util/rooms";

    export default {
        components: {
            FilterPage,
            RangeCriteria,
            BFormCheckbox,
        },
        props: {
            value: Object,
            criterias: Object,
        },
        computed: {
            ranges() {
                return getRoomsCriterias(this.criterias, this.value);
            },
        },
        methods: {
            rangeValue(name) {
                return roomValue(this.value, name);
            },
            rangeUnit(name) {
                return isRoomValueInMeter(name) ? 'm.' : null;
            },
            handleChanged(name, value) {
                this.value.venues.rooms = {
                    ...this.value.venues.rooms,
                    [name]: value,
                };
                this.$emit('input', { ...this.value });
            },
            handleIsTentChanged(checked) {
                this.value.venues.rooms = {
                    is_tent: checked,
                };
                this.$emit('input', { ...this.value });
            },
            handleReset() {
                this.value.venues.rooms = {};
                this.$emit('input', { ...this.value });
            },
        },
        created() {
            this.value.venues.rooms = { ...this.value.venues.rooms };
        }
    }
</script>